<div class="lum-modal lum-c-order-shipments-form">
  <!-- Modal Header -->
  <div class="lum-modal__header flex justify-space-between w-p100">
    <span class="lum-modal__header-title flex text-large">
      {{ isEditing ? 'Edit Shipment' : 'Create Shipment' }}
    </span>
    <div class="lum-modal__header-close">
      <button
        type="button"
        class="lum-button lum-button--secondary"
        mat-button
        (click)="onClose()"
      >
        <lum-ui-icon
          class="mr-2-5"
          icon="close-circle"
          color="#5563D6"
          width="23"
          height="23"
        ></lum-ui-icon>
        Close
      </button>
    </div>
  </div>

  <!-- Loader / Shipment Form-->
  <mat-dialog-content>
    <ng-container
      *ngIf="loading$ | async; then loader; else shipmentFormContent"
    ></ng-container>
  </mat-dialog-content>

  <hr class="my-3" />
  <mat-dialog-actions align="end">
    <button
      mat-button
      type="button"
      class="lum-button"
      [disabled]="shipmentForm.invalid || !hasIncludedItems"
      (click)="onSubmit()"
    >
      Save
    </button>
  </mat-dialog-actions>

  <div
    class="overlay"
    lumAppLoader
    [loading]="submitting$ | async"
    [classes]="'loading blur'"
  ></div>
</div>

<!-- Loader Template -->
<ng-template #loader>
  <div
    class="d-flex justify-content-center align-items-center"
    style="min-height: 300px"
  >
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>
</ng-template>

<!-- Shipment Form Template -->
<ng-template #shipmentFormContent>
  <form [formGroup]="shipmentForm" (ngSubmit)="onSubmit()">
    <div class="p-5">
      <!-- Shipment Details -->
      <h5 class="text-lg font-bold mb-2">Shipment Details</h5>
      <hr class="my-3" />
      <div class="row">
        <div class="form-group col-md-6">
          <label>Fulfillment Order ID</label>
          <ng-container *ngIf="!shipmentForm.get('fulfillmentOrderId')?.disabled">
            <lum-fulfillment-order-autocomplete-control
              formControlName="fulfillmentOrder"
              [queryParams]="{ 'filters[]': 'salesOrderId|eq|' + salesOrderId }"
            ></lum-fulfillment-order-autocomplete-control>
          </ng-container>
          <ng-container *ngIf="shipmentForm.get('fulfillmentOrderId')?.disabled">
            <input
              type="text"
              class="lum-input"
              formControlName="fulfillmentOrderId"
            />
          </ng-container>
        </div>
        <div class="form-group col-md-6">
          <label>Warehouse Group</label>
          <input type="text" class="lum-input" formControlName="warehouseGroup" />
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-3">
          <label>Shipment ID</label>
          <input
            type="txt"
            class="lum-input"
            formControlName="shipmentId"
            [placeholder]="shipmentForm.get('shipmentId')?.value"
          />
        </div>
        <div class="form-group col-md-3">
          <label>Carrier</label>
          <input type="text" class="lum-input" formControlName="carrierCode" />
        </div>
        <div class="form-group col-md-3">
          <label>Tracking Number</label>
          <input type="text" class="lum-input" formControlName="trackingNumber" />
        </div>
        <div class="form-group col-md-3">
          <label>SSCC</label>
          <input type="text" class="lum-input" formControlName="sscc" />
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-3">
          <label>Ship Date</label>
          <input type="date" class="lum-input" formControlName="shipDate" />
        </div>
        <div class="form-group col-md-3">
          <label>Cost</label>
          <input type="text" class="lum-input" formControlName="cost" />
        </div>
        <div class="form-group col-md-3">
          <label>Status</label>
          <select class="lum-input" formControlName="status">
            <option value="PENDING">PENDING</option>
            <option value="SHIPPED">SHIPPED</option>
          </select>
        </div>
      </div>

      <!-- Weight & Dimensions -->
      <h5 class="text-lg font-bold mt-5 mb-2">Weight & Dimensions</h5>
      <hr class="my-3" />
      <div class="row">
        <div class="form-group col-md-3" formGroupName="weight">
          <label>Weight</label>
          <div class="shipping-quote__input flex">
            <div class="flex align-center gap-1">
              <div class="flex flex-column">
                <input
                  formControlName="value"
                  type="number"
                  min="0"
                  matInput
                  class="lum-input"
                />
              </div>
              <div class="flex justify-content-end">
                <span
                  class="text-underline cursor-pointer text-purple-600 font-semi-bold"
                  #menuTrigger="matMenuTrigger"
                  [matMenuTriggerFor]="weightMenu"
                >
                  ({{ weightUnit }})
                </span>
                <mat-menu class="lum-mat-menu" #weightMenu="matMenu">
                  <button
                    *ngFor="let unit of weightUnits; trackBy: trackByLabel"
                    mat-menu-item
                    (click)="onSetUnit('weight.units', unit.value)"
                  >
                    {{ unit.value }} ({{ unit.label }})
                  </button>
                </mat-menu>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group col-md-9" formGroupName="dimensions">
          <label>Size</label>
          <div class="d-flex justify-space-between gap-7">
            <div class="flex align-center gap-1">
              <input
                formControlName="length"
                type="number"
                min="0"
                matInput
                class="lum-input"
              />
              L
            </div>
            <div class="flex align-center gap-1">
              <input
                formControlName="width"
                type="number"
                min="0"
                matInput
                class="lum-input"
              />
              W
            </div>
            <div class="flex align-center gap-1">
              <input
                formControlName="height"
                type="number"
                min="0"
                matInput
                class="lum-input"
              />
              H
              <span
                class="text-underline cursor-pointer text-purple-600 font-semi-bold"
                #menuTrigger="matMenuTrigger"
                [matMenuTriggerFor]="dimensionMenu"
              >
                ({{ dimensionUnit }})
              </span>
              <mat-menu class="lum-mat-menu" #dimensionMenu="matMenu">
                <button
                  *ngFor="let unit of dimensionUnits; trackBy: trackByLabel"
                  mat-menu-item
                  (click)="onSetUnit('dimensions.units', unit.value)"
                >
                  {{ unit.value }} ({{ unit.label }})
                </button>
              </mat-menu>
            </div>
          </div>
        </div>
      </div>

      <!-- Line Items -->
      <h5 class="text-lg font-bold mt-5 mb-2">
        Line Items
        <span
          class="text-small text-red-500 ml-2"
          *ngIf="!hasIncludedItems && !isEditing"
        >
          (At least one included item is required.)
        </span>
      </h5>
      <hr class="my-3" />
      <div>
        <table class="lum-table lum-table--striped w-100">
          <thead>
            <tr>
              <th class="p-2" *ngIf="!isEditing">Include</th>
              <th class="p-2">Item SKU</th>
              <th class="p-2">Item Name</th>
              <th class="p-2" width="200">Item Quantity</th>
              <th class="p-2 text-center">Available Qty</th>
            </tr>
          </thead>
          <tbody formArrayName="items">
            <tr
              *ngFor="
                let item of shipmentForm.get('items')?.controls || [];
                let i = index;
                trackBy: trackByControlValue
              "
              [formGroupName]="i"
            >
              <td class="p-2" *ngIf="!isEditing">
                <mat-checkbox
                  class="lum-checkbox"
                  formControlName="include"
                  matTooltip="Cannot include item without available remaining quantity."
                  matTooltipPosition="below"
                  [matTooltipDisabled]="!item.get('include')?.disabled"
                  [style.cursor]="
                    item.get('include')?.disabled ? 'not-allowed' : 'auto'
                  "
                ></mat-checkbox>
              </td>
              <td class="p-2">
                {{ item.get('sku').value }}
              </td>
              <td class="p-2">
                {{ item.get('productName').value }}
              </td>
              <td class="p-2">
                <div
                  class="d-flex align-center gap-1"
                  [matTooltip]="
                    isEditing
                      ? 'Cannot edit quantity if shipment is already shipped.'
                      : 'This line item has no remaining quantity.'
                  "
                  [matTooltipDisabled]="!item.get('quantity')?.disabled"
                  matTooltipPosition="below"
                >
                  <input
                    lumDecimalLimit
                    type="text"
                    class="lum-input w-16"
                    formControlName="quantity"
                    [style.cursor]="
                      item.get('quantity')?.disabled ? 'not-allowed' : 'auto'
                    "
                    [allowNegative]="false"
                  />
                  <span
                    >/ {{ item.get('remainingQty').value | decimalPlaces }}</span
                  >
                  <i
                    *ngIf="
                      item.get('quantity').hasError('exceedsAvailable') &&
                      !item.get('quantity').disabled
                    "
                    [matTooltip]="'Quantity cannot exceed remaining quantity.'"
                    matTooltipPosition="right"
                    class="fa fa-exclamation-triangle text-red-300 ml-2 cursor-pointer"
                  ></i>
                </div>
              </td>
              <td class="p-2 text-center">
                {{ item.get('availableQty').value | decimalPlaces }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </form>
</ng-template>
